import { render, staticRenderFns } from "./SettingsGlobalConfigView.vue?vue&type=template&id=065c5f51&scoped=true&"
import script from "./SettingsGlobalConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsGlobalConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGlobalConfigView.vue?vue&type=style&index=0&id=065c5f51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c5f51",
  null
  
)

export default component.exports